export default __webpack_public_path__ + "static/media/bb12.9c9d25da.webp";